module.exports = __webpack_public_path__ + "static/media/11a-05-ST-2011_75x100cm-oleo-sobre-papel.984e9487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/11/11a-05-ST-2011_75x100cm-oleo-sobre-papel.jpg
// module id = 125
// module chunks = 0